import React, {Component} from 'react'
import {reduxForm, Field} from "redux-form";
import {STATE_MAIL_SENDED, STATE_SEND_MAIL, STATE_CHANGE_PASSWORD, STATE_PASSWORD_CHANGED} from '../containers/PasswordRecoveryContainer'
import {NavLink} from "react-router-dom";

import SplashBtn from '../components/SplahsBtn'


class PasswordRecovery extends Component {
    render() {
        return(
            <form onSubmit={this.props.handleSubmit}>
            <div>
                    <div className="col-md-4 col-md-offset-4 ">
                        <div className="panel panel-default">
                            <div className="panel-body">
                            {this.props.currentState === STATE_SEND_MAIL && <div>
                                <div className="text-recovey-password">
                                    <h2>Recupera password</h2>
                                </div>
                                <p>Inserisci la mail con cui ti sei registrato,<br/> ti manderemo una mail per resettare la password</p>
                                    <Field required component="input" name="email" type="text" className="inputLogin" placeholder="E-mail" aria-describedby="basic-addon1" />
                                {this.props.formError && <div><span style={{color: 'red'}}>{this.props.formError}</span></div>}
                                <SplashBtn> Invio </SplashBtn>
                            </div>}

                            {this.props.currentState === STATE_MAIL_SENDED && <div>
                                <div className="testo">
                                    <h2>E-mail Inviata</h2>
                                </div>
                                {!this.props.formError && <h6>Ti abbiamo inviato una e-mail, segui le istruzioni presenti all'interno per continuare</h6>}
                                {this.props.formError && <div><span style={{color: 'red'}}>{this.props.formError}</span></div>}
                            </div>}

                            {this.props.currentState === STATE_CHANGE_PASSWORD && <div>
                                <div className="testo">
                                    <h2>Richiedi nuova password</h2>
                                </div>
                                <p>Inserisci la tua nuova password</p>
                                    <Field required component="input" name="password" type="password" className="inputLogin" placeholder="Nuova Password" aria-describedby="basic-addon1" />
                                    <Field required component="input" name="repeatedPassword" type="password" className="inputLogin" placeholder="Ripeti password" aria-describedby="basic-addon1" />

                                {this.props.formError && <div><span style={{color: 'red'}}>{this.props.formError}</span></div>}
                                <SplashBtn> Invio </SplashBtn>
                            </div>}

                            {this.props.currentState === STATE_PASSWORD_CHANGED && <div>
                                <div className="testo">
                                    <h2>Password Modificata con Successo</h2>
                                </div>
                                <p>La tua password è stata modificata correttamente.</p>
                                <SplashBtn><NavLink className="" to="/">VAI AL LOGIN</NavLink></SplashBtn>
                            </div>}
                        </div>
                    </div>
                    </div>
            </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'passwordRecovery'
})(PasswordRecovery)


// WEBPACK FOOTER //
// ./src/screens/PasswordRecoveryScreen.js